var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.32751,
    y: 5.58752,
    width: 12.2925,
    height: 7.82252,
    fill: "#FFEFDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 2.88627C19.2425 4.01703 19.2425 5.49728 19.2425 8.45778V11.311C19.2425 11.6067 19.2425 11.7545 19.2366 11.8794C19.1077 14.6024 16.9293 16.7808 14.2063 16.9096C14.0815 16.9156 13.9166 16.9156 13.5868 16.9156L13.5021 16.9157C12.4235 16.9225 11.3728 17.2593 10.4911 17.8806L10.435 17.9206L7.67491 19.8921C6.72871 20.5678 5.48535 19.5918 5.91719 18.5123C6.2231 17.7475 5.65987 16.9156 4.83619 16.9156H4.20001C1.99778 16.9156 0.212524 15.1303 0.212524 12.928V8.45778C0.212524 5.49728 0.212524 4.01703 0.788676 2.88627C1.29547 1.89162 2.10415 1.08294 3.09879 0.576151C4.22956 0 5.70981 0 8.6703 0H10.7847C13.7453 0 15.2255 0 16.3563 0.576151C17.3509 1.08294 18.1596 1.89162 18.6663 2.88627ZM6.55586 8.45778C6.55586 9.04166 6.08252 9.515 5.49864 9.515C4.91475 9.515 4.44141 9.04166 4.44141 8.45778C4.44141 7.8739 4.91475 7.40056 5.49864 7.40056C6.08252 7.40056 6.55586 7.8739 6.55586 8.45778ZM10.7847 8.45778C10.7847 9.04166 10.3114 9.515 9.72752 9.515C9.14364 9.515 8.6703 9.04166 8.6703 8.45778C8.6703 7.8739 9.14364 7.40056 9.72752 7.40056C10.3114 7.40056 10.7847 7.8739 10.7847 8.45778ZM13.9564 9.515C14.5403 9.515 15.0136 9.04166 15.0136 8.45778C15.0136 7.8739 14.5403 7.40056 13.9564 7.40056C13.3725 7.40056 12.8992 7.8739 12.8992 8.45778C12.8992 9.04166 13.3725 9.515 13.9564 9.515Z",
    fill: "#FAAA52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatActive);
export default __webpack_public_path__ + "static/media/Icon.ChatActive.9f0ec4b762aa1627e602533f285e5a51.svg";
export { ForwardRef as ReactComponent };